export default v =>
  v !== null &&
  typeof v !== "undefined" &&
  (typeof v !== "string" || v.trim().length > 0);
